<template>
	<div>
		<form-dialog
			:appendToBody="true"
			:dialogVisible.sync="dialog_visible"
			:formData="formData"
			ref="formData"
			dialogWidth="600px"
			@handleClose="close"
		>
			<dialog-title slot="title" :title="title" :subtitle="subtitle"></dialog-title>

			<dialog-footer
				slot="footer"
				:visible.sync="dialog_visible"
				@confirm="submit"
				@onclose="close"
			></dialog-footer>
		</form-dialog>
	</div>
</template>
<script>
import formDialog from '@/components/webManage/formDialog.vue';
import dialogTitle from '@/components/crm/crm-dialog-title.vue';
import Name from '@/components/crm/crm-form-name.vue';
import dialogFooter from '@/components/crm/crm-dialog-footer.vue';
import { validRequired } from '@/common/elementValid.js';
import customSer from '@/client/services/customerManage/customerSer.js';
import { mapGetters, mapActions } from 'vuex';
export default {
	props: {
		visible: {
			type: Boolean,
		},
		data: {
			type: Object,
		},
	},
	data() {
		let that = this;
		return {
			title: '客户转移',
			subtitle: '您正在进行转移客户操作',
			avatarUrl: '',
			employee: [],
			formData: {
				customerId: {
					displayWith: () => false,
					formType: 'sky-input',
					value: '',
				},
				name: {
					label: '公司名称：',
					formType: Name,
					value: '',
				},
				move: {
					label: '转移至：',
					key: 'targetEmployeeId',
					value: '',
					options: that.getEmployee,
					formType: 'sky-select',
					props: {
						label: 'name',
						value: 'id',
					},
					rules: [validRequired('请选择服务人员', 'change')],
					change(val) {
						if (that.employee && that.employee.length > 0) {
							that.employee.forEach(e => {
								if (e.id == val) {
									that.avatarUrl = e.avatarUrl;
								}
							});
						}
					},
				},
			},
			dialog_visible: false,
		};
	},
	watch: {
		visible: {
			handler() {
				this.dialog_visible = this.visible;
				this.formData.customerId.value = this.data.customerId;
				this.formData.name.value = this.data.customerName;
			},
		},
	},
	computed: {
		...mapGetters(['chatListData', 'allChatList']),
	},
	methods: {
		...mapActions(['getEmployeeList']),
		async getEmployee() {
			this.employee = await this.getEmployeeList();
			return this.employee;
		},
		submit() {
			this.$refs.formData.validate(async valid => {
				if (valid) {
					const res = await customSer.transferCustomer({
						customerId: this.formData.customerId.value,
						targetEmployeeId: this.formData.move.value,
					});
					if (res) {
						//对聊天列表数据进行处理，客户转移，跟进人字段更新，请求聊天记录接口，抽屉关闭
						let item;
						if (this.$route.name == 'allChat') {
							item = this.allChatList.find(e => e.id == this.data.customerId);
							//列表跟进人数据替换，跟进人列表-----跳转数据处理有问题
							this.allChatList.forEach(e => {
								if (e.id == this.data.customerId) {
									e.followupName = this.formData.move.value;
									e.followupHeadPath = this.avatarUrl;
								}
							});
						} else {
							item = this.chatListData.find(e => e.id == this.data.customerId);
							//列表跟进人数据替换，跟进人列表-----跳转数据处理有问题
							this.chatListData.forEach(e => {
								if (e.id == this.data.customerId) {
									e.followupName = this.formData.move.value;
									e.followupHeadPath = this.avatarUrl;
								}
							});
						}
						this.$router.push({
							name: this.$route.name,
							query: {
								followupName: this.formData.move.value,
								type: item.type,
								id: item.id,
								tableId: item.tableId,
							},
						});
						this.$emit('changeName');
						this.$message.success(`操作成功`);
						this.close();
					} else {
						this.$message.info(`操作失败`);
					}
				}
			});
		},
		close() {
			this.dialog_visible = false;
			this.$emit('update:visible', false);
		},
	},
	components: {
		formDialog,
		dialogTitle,
		Name,
		dialogFooter,
	},
};
</script>
<style lang="scss" scoped></style>
